/* eslint-disable vue/valid-template-root */
<template>

<div class="monochrome">
    <Navbar />
        <section>
        <div class="container">
            <div class="text text-white">
                <h2>Monochrome, Website E-Commerce</h2>

                <figure class="figure text-left">
                    <a target="_blank" href="https://monochrome-store.netlify.app" style="font-size: 14px;"><i class="fas fa-link ml-2 mt-5"></i> Visit Website</a>
                    <img src="assets/img/mono.png" class="figure-img img-fluid mt-5" data-aos="flip-left"
                        data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                    <figcaption class="figure-caption mt-3 text-center font-italic text-white">
                        Monochrome Project Web Design
                    </figcaption>
                </figure>
            </div>
        </div>
    </section>

    <!-- Problem Statement -->
    <section>
        <div class="container text-left">
            <div class="row" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <h6 class="text-title">PROBLEM STATEMENT</h6>
                    <p class="text-desc">From the result customer persona, the customers online shopping experience
                        wants the confidentiality of the items
                        purchased so that goods such as intimate things can be protected in secret. <br><br> And there
                        can be
                        customers who want to know
                        designer who have made products.
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Problem Statement -->
    <!-- Project Goals -->
    <section>
        <div class="container text-left">
            <h6 class="text-title">PROJECT GOALS</h6>
            <div class="row" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/satu.png" class="mt-5" alt="">
                    <p class="text-desc">Differenciate from competitors<br>through innovation</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/tiga.png" class="mt-5" alt="">
                    <p class="text-desc">Use technology to complement<br>the in store experience</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/dua.png" class="mt-5" alt="">
                    <p class="text-desc">Estabilish trust and credibility<br>through excellent service</p>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Project Goals -->
    <!-- Research Methods -->
    <section>
        <div class="container text-left">
            <h6 class="text-title">RESEARCH METHODS</h6>
            <div class="row" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/research.png" class="mt-5" width="11%" alt="">
                    <p class="text-desc">Competitive research</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/Group 44.png" class="mt-5" width="9%%" alt="">
                    <p class="text-desc">UX Survey</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/persona.png" class="mt-5" width="10%" alt="">
                    <p class="text-desc">Customer persona</p>
                </div>
                <div class="col col-lg-6 col-md-6 col-12">
                    <img src="assets/img/userflow.png" class="mt-5" width="13%" alt="">
                    <p class="text-desc">User flow & Journey</p>
                </div>
                <div class="col col-lg-6 col-md-6 col-12">
                    <img src="assets/img/prototype.png" class="mt-5" width="7%" alt="">
                    <p class="text-desc">Prototype testing</p>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Reseacrh and methods -->
    <!-- Scope and constraints -->
    <section>
        <div class="container text-left">
            <div class="row" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <h6 class="text-title">SCOPE AND CONSTRAINTS</h6>
                    <p class="text-desc">Assets that I use from several platforms including for the image I took
                        from <a href="https://www.zara.com/">ZARA</a>. For icons I took from <a
                            href="https://www.flaticon.com/">flaticons</a>, <a
                            href="https://fontawesome.com/">fontawesome</a> and some I made myself.
                        <br><br> I design the web design for shopping online (e-commerce) and develop it. Then I
                        also design all
                        the inner pages such as
                        home page, category page, designer page, product page, detail product page, success page
                        (modal), about page redirect to the company profile, and footer.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <figure class="figure mt-5">
                        <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/homepage.png" class="figure-img img-fluid mt-5">
                    </figure>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/style.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Scope and constraints -->
    <!-- Sitemap -->
    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">SITEMAP</h6>
                    <p class="text-desc">This sitemap is very useful to see how big the scope is and also as my guide
                        when designing the pages. When the sitemap is done, the next step wireframe.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/sitemap-mono.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Close Sitemap -->
    <!-- Wireframe -->
    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">WIREFRAME</h6>
                    <p class="text-desc">I use the actual content from them (<a
                            href="https://buildwithangga.com/">BuildWithAngga</a>) and also the layout but
                        there are some that I redesign. I find this wireframe process is very important so I can focus
                        on the content first. I designed the wireframe for all the pages using Adobe XD tools.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/wireframe-mono.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Close wireframe -->
    <!-- mockup -->
    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">MOCKUP</h6>
                    <p class="text-desc">After finished creating the wireframe in Adobe XD. I continue to the mockup
                        phase. Filling the images, creating some design elements, adding colors, and refining the
                        layout. Of the wireframe that was created, I don't follow all the layout. There are some parts
                        that I changed.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/mockup-mono.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- close mockup -->
    <!-- result -->
    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">RESULT</h6>
                    <p class="text-desc">With some revisions, the final design is finally done. Then the next step is
                        the development process by my self. After about 1 month of development the site ready to
                        deploy and now you can see it in action. Indeed it took quite a long time because I had to
                        finish the class first.
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- close result -->
    <!-- screen -->
    <section>
        <div class="container text-left">
            <figure class="figure mt-5">
                <img src="assets/img/screen.png" class="figure-img img-fluid mt-5">
            </figure>
        </div>
    </section>
    <!-- close screen -->
    <Footer />
</div>
</template>

<script>
import Footer from '../components/Footer.vue';
import Navbar from '../components/NavbarSection.vue';
export default {
    name: 'mono',
    components: { 
        Navbar,
        Footer
    },
}
</script>

<style>
    * {
        font-family: 'Rubik', sans-serif;
    }
    .text-desc {
        color: white !important;
    }
</style>